// extracted by mini-css-extract-plugin
export var searchHeader = "_redotech-arbiter-lib-list-redo-list-dropdown-searchHeader";
export var searchHeaderDark = "_redotech-arbiter-lib-list-redo-list-dropdown-searchHeaderDark";